
<div id="carruselImagenes" class="carousel slide" data-ride="carousel">
    <ol class="carousel-indicators">
      <li data-target="#carruselImagenes" data-slide-to="0" class="active"></li>
      <li data-target="#carruselImagenes" data-slide-to="1"></li>
      <li data-target="#carruselImagenes" data-slide-to="2"></li>
      <li data-target="#carruselImagenes" data-slide-to="3"></li>
      <li data-target="#carruselImagenes" data-slide-to="4"></li>
    </ol>
    <div class="carousel-inner">
      <div class="carousel-item active">
        <img class="d-block w-100" src="./assets/images/carrusel/imagen01.png" alt="First slide">
      </div>
      <div class="carousel-item">
        <img class="d-block w-100" src="./assets/images/carrusel/imagen02.png" alt="Second slide">
      </div>
      <div class="carousel-item">
        <img class="d-block w-100" src="./assets/images/carrusel/imagen03.png" alt="Third slide">
      </div>
      <div class="carousel-item">
        <img class="d-block w-100" src="./assets/images/carrusel/imagen04.png" alt="Four slide">
      </div>
      <div class="carousel-item">
        <img class="d-block w-100" src="./assets/images/carrusel/imagen05.png" alt="Five slide">
      </div>
    </div>
    <a class="carousel-control-prev" href="#carruselImagenes" role="button" data-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="sr-only">Atras</span>
    </a>
    <a class="carousel-control-next" href="#carruselImagenes" role="button" data-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="sr-only">Proximo</span>
    </a>
</div>
